import React from "react"
import ReactDOM from "react-dom"
import App from "./App"

import "./css/style.css" // Production
// import "./sass/main.scss" // Development

ReactDOM.render(<App />, document.getElementById("root"))
